import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { AiOutlineArrowRight } from 'react-icons/ai';
import image1 from "../../../assets/images/CompanyLogo/Uber.svg";
import image2 from "../../../assets/images/CompanyLogo/Adobe.svg";
import image3 from "../../../assets/images/CompanyLogo/Airbnbairbnb.svg";
import image4 from "../../../assets/images/CompanyLogo/Afterpayafterpay.svg";
import image5 from "../../../assets/images/CompanyLogo/Airwallexairwall.svg";
import image6 from "../../../assets/images/CompanyLogo/Airtableairtable.svg";
import bg1 from "../../../assets/images/CompanyLogo/bg1.svg";

const Companies = () => {
  const options = ["IT Sector", "Electronics Appliances", "Banking & Finance", "Real Estate business"];

  const [selectedOption, setSelectedOption] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const companies = [
    {
      option: 0,
      logo: image1,
      text: "UBER India system private limited"
    },
    {
      option: 1,
      logo: image2,
      text: "Adobe Systems Incorporated"
    },
    {
      option: 2,
      logo: image3,
      text: "Random Description 1"
    },
    {
      option: 3,
      logo: image4,
      text: "Random Description 2"
    },
    {
      option: 1,
      logo: image5,
      text: "Airwallex Ltd"
    },
    {
      option: 1,
      logo: image6,
      text: "Airtable Inc."
    }
  ];


  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 640);
    };

    handleResize();
    window.addEventListener("resize", handleResize); 
    return () => {
      window.removeEventListener("resize", handleResize); 
    };
  }, []);

  return (
    <div className="w-full flex flex-col px-4 py-4 mt-8 lg:flex-row sm:px-8 md:px-16 lg:px-32 py-auto md:py-28 justify-center lg:justify-between items-center overflow-hidden"
      style={{
        background: `url(${bg1}) no-repeat center center / cover`,
        padding: '32px', 
      }}>
      <div className="max-w-[1200px] m-0 mx-auto sm:flex w-full justify-center text-center mb-6 lg:mb-0">
        <div className="text-center">
          <h2 className="text-center sm:text-left flex flex-col w-full mb-6 text-[#EBF0F3] font-sans text-f24 md:text-f30 lg:text-f40 font-bold">
          Verified Businesses Near You
          </h2>

          {isSmallScreen ? (
            <Carousel
              showThumbs={false}
              showIndicators={false}
              showStatus={false}
              showArrows
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && (
                  <button
                    type="button"
                    onClick={onClickHandler}
                    title={label}
                    className="absolute z-10 -left-12 top-1/2 transform -translate-y-1/2 focus:outline-none"
                  >
                    <AiOutlineArrowRight className="w-5 h-5" />
                  </button>
                )
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && (
                  <button
                    type="button"
                    onClick={onClickHandler}
                    title={label}
                    className="absolute z-10 -right-12 top-1/2 transform -translate-y-1/2 focus:outline-none"
                  >
                    <AiOutlineArrowRight className="w-5 h-5" />
                  </button>
                )
              }
            >
             
              {options.map((option, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedOption(index)}
                  className={`text-left p-3 text-[#EBF0F3] rounded  ${selectedOption === index ? 'border-[1px] border-[#D1D5DB]' : ''
                    }`}
                >
                  {option}
                </div>
              ))}
              
            </Carousel>
          ) : (
            options.map((option, index) => (
              <div
                key={index}
                onClick={() => setSelectedOption(index)}
                className={`mb-7 hidden  sm:flex items-center text-[#EBF0F3] rounded ${selectedOption === index ? 'border-[1px] w-[250px] h-[40px] p-2 border-[#D1D5DB]' : ''
                  }`}
              >
                {option}
              </div>
            ))
          )}
        </div>
        <div className="grid mt-[24px] grid-cols-2 lg:grid-cols-3 grid-rows-3 lg:grid-rows-2 md:gap-0">
          {companies.map((company, index) => (
            <div
              key={index}
              className={`px-8 flex max-w-full pt-11 pb-5  md:w-[400px] h-40 md:h-56 flex-col justify-start items-center gap-6 md:gap-8 ${index % 2 !== 1 ? 'border-r-[1px] border-[#F4E8E5]' : ''
                } ${index === 2 ? 'lg:border-r-0' : ''} ${index === 3 ? 'lg:border-b-0' : ''
                } ${index < 4 ? 'border-b-[1px] border-[#F4E8E5]' : ''} ${index % 3 !== 2 ? 'lg:border-r-[1px] lg:border-[#F4E8E5]' : ''
                } ${index < 2 ? 'border-b-[1px] border-[#F4E8E5]' : ''} ${index % 3 !== 2 ? 'lg:border-r-[1px] lg:border-[#F4E8E5]' : ''
                } ${index < 3 ? 'lg:border-b-[1px] lg:border-[#F4E8E5]' : ''}`}
            >
              <img
                src={company.logo}
                alt={company.name}
                className="max-w-full h-16 "
                style={{ objectFit: 'contain' }}
              />
              <p className="text-[#EBF0F3] text-f10 md:text-f16 lg:text-base s:w-40">
                {selectedOption === 0 || selectedOption === company.option
                  ? company.text
                  : "Random Description"}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Companies;